import React, { type ComponentType, type HTMLAttributes } from 'react';
import styles from './SelectQuestion.scss';

type Props = React.DetailedHTMLProps<
  HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;

export const InputContainer: ComponentType<Props> = ({
  children,
  ...otherProps
}) => (
  <div className={styles.inputContainer} {...otherProps}>
    {children}
  </div>
);
